import serviceHandler from "@/helpers/handlers/service";
import storeLocatorService from "@/services/storeLocator";

export const storeLocatorFaqMixin = {
  data() {
    return {
      commonFaq: []
    };
  },

  methods: {
    async initializeCommonFaq() {
      await this.withLoadingState(this.getCommonFaq);
    },
    async withLoadingState(callback) {
      this.isLoading = true;
      try {
        await callback();
      } finally {
        this.isLoading = false;
      }
    },
    async getCommonFaq() {
      this.commonFaq = await serviceHandler(
        storeLocatorService.getDefaultFaq()
      );
    }
  }
};
